import { Tabs } from "./tabs.js";

export default function initTabs() {
  const instances = [];

  document.querySelectorAll(".js-tabs").forEach((el) => {
    const instance = Tabs(el);
    if (instance) instances.push(instance);
  });

  return instances;
}
